/**
 * Additional Information Section JavaScript
 * Handles tab functionality and accessibility
 */

(function () {
  "use strict";

  function isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  function initAccordion() {
    var accordion = document.getElementById("product-detail-accordion");
    if (!accordion) return;
    var buttons = accordion.querySelectorAll(".accordion-button");
    var panels = accordion.querySelectorAll(".accordion-collapse");

    function openAccordion(idx) {
      buttons.forEach(function (btn, i) {
        var expanded = i === idx;
        btn.classList.toggle("active", expanded);
        btn.setAttribute("aria-expanded", expanded ? "true" : "false");
        panels[i].classList.toggle("show", expanded);
      });
    }

    // Set up click handlers
    buttons.forEach(function (btn, idx) {
      btn.addEventListener("click", function () {
        if (btn.classList.contains("active")) {
          // Optionally allow closing all, or keep one always open
          return;
        }
        openAccordion(idx);
      });
      // Keyboard accessibility
      btn.addEventListener("keydown", function (e) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          var next = buttons[idx + 1] || buttons[0];
          next.focus();
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          var prev = buttons[idx - 1] || buttons[buttons.length - 1];
          prev.focus();
        } else if (e.key === "Home") {
          e.preventDefault();
          buttons[0].focus();
        } else if (e.key === "End") {
          e.preventDefault();
          buttons[buttons.length - 1].focus();
        }
      });
    });
    // Open first by default
    openAccordion(0);
  }

  function destroyAccordion() {
    var accordion = document.getElementById("product-detail-accordion");
    if (!accordion) return;
    var buttons = accordion.querySelectorAll(".accordion-button");
    var panels = accordion.querySelectorAll(".accordion-collapse");
    buttons.forEach(function (btn) {
      btn.classList.remove("active");
      btn.setAttribute("aria-expanded", "false");
    });
    panels.forEach(function (panel) {
      panel.classList.remove("show");
    });
  }

  function handleResize() {
    if (isMobile()) {
      initAccordion();
    } else {
      destroyAccordion();
    }
  }

  // Tab JS (desktop) - keep existing logic
  function initTabs() {
    var tabContainer = document.getElementById("product-detail-tabs");
    if (!tabContainer) return;

    // Only initialize tab functionality if this is a real tab interface (has role="tablist")
    var isTabInterface = tabContainer.getAttribute("role") === "tablist";
    if (!isTabInterface) return;

    var tabButtons = tabContainer.querySelectorAll(".nav-link");
    var tabPanes = document.querySelectorAll(".tab-pane");
    tabButtons.forEach(function (button) {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        var targetId = this.getAttribute("data-bs-target");
        var targetPane = document.querySelector(targetId);
        if (!targetPane) return;
        tabButtons.forEach(function (btn) {
          btn.classList.remove("active");
          btn.setAttribute("aria-selected", "false");
        });
        tabPanes.forEach(function (pane) {
          pane.classList.remove("active", "show");
        });
        this.classList.add("active");
        this.setAttribute("aria-selected", "true");
        targetPane.classList.add("active", "show");
        var event = new CustomEvent("tabChanged", {
          detail: {
            tabId: this.id,
            paneId: targetId,
          },
        });
        document.dispatchEvent(event);
      });
    });
    tabButtons.forEach(function (button, index) {
      button.addEventListener("keydown", function (e) {
        switch (e.key) {
          case "ArrowLeft":
            e.preventDefault();
            var prevButton =
              tabButtons[index - 1] || tabButtons[tabButtons.length - 1];
            prevButton.focus();
            prevButton.click();
            break;
          case "ArrowRight":
            e.preventDefault();
            var nextButton = tabButtons[index + 1] || tabButtons[0];
            nextButton.focus();
            nextButton.click();
            break;
          case "Home":
            e.preventDefault();
            tabButtons[0].focus();
            tabButtons[0].click();
            break;
          case "End":
            e.preventDefault();
            tabButtons[tabButtons.length - 1].focus();
            tabButtons[tabButtons.length - 1].click();
            break;
        }
      });
    });
    var firstTab = tabButtons[0];
    if (firstTab) {
      firstTab.setAttribute("aria-selected", "true");
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    initTabs();
    handleResize();
  });
  window.addEventListener("resize", handleResize);

  // Export for potential external use
  window.AdditionalInformationTabs = {
    initializeTabs: initTabs,
    initializeAccordion: initAccordion,
  };
})();
